import { lazy } from 'react'
import { SoParametersPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOParameters/rbac'
import { SoSchedulesPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOSchedules/rbac'
import { SoReportPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOReports/rbac'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

const SOParameters = lazy(() => import('../pages/SOParameters'))
const SOReports = lazy(() => import('../pages/SOReports'))
const SOSchedules = lazy(() => import('../pages/SOSchedules'))
const SOSchedulesAddEdit = lazy(() => import('../pages/SOSchedulesAddEdit'))

export const SOParametersRouter: RouterFeatureInterface<
  'SOParametersRouter',
  '/dashboard/so-automation/so-parameters'
> = {
  name: 'SOParametersRouter',
  Component: SOParameters,
  path: '/dashboard/so-automation/so-parameters',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SoParametersPageRBAC.pageID,
  isDashboard: true,
}

export const SOSchedulesRouter: RouterFeatureInterface<
  'SOSchedulesRouter',
  '/dashboard/so-automation/so-schedules'
> = {
  name: 'SOSchedulesRouter',
  Component: SOSchedules,
  path: '/dashboard/so-automation/so-schedules',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SoSchedulesPageRBAC.pageID,
  isDashboard: true,
}

export const SOSchedulesAddRouter: RouterFeatureInterface<
  'SOSchedulesAddRouter',
  '/dashboard/so-automation/so-schedules/add'
> = {
  name: 'SOSchedulesAddRouter',
  Component: SOSchedulesAddEdit,
  path: '/dashboard/so-automation/so-schedules/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SoSchedulesPageRBAC.pageID,
  isDashboard: true,
}

export const SOSchedulesEditRouter: RouterFeatureInterface<
  'SOSchedulesEditRouter',
  '/dashboard/so-automation/so-schedules/edit/:id'
> = {
  name: 'SOSchedulesEditRouter',
  Component: SOSchedulesAddEdit,
  path: '/dashboard/so-automation/so-schedules/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SoSchedulesPageRBAC.pageID,
  isDashboard: true,
}

export const SOReportsRouter: RouterFeatureInterface<
  'SOReportsRouter',
  '/dashboard/so-automation/so-reports'
> = {
  name: 'SOReportsRouter',
  Component: SOReports,
  path: '/dashboard/so-automation/so-reports',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SoReportPageRBAC.pageID,
  isDashboard: true,
}

const SOAutomationRouter = [
  SOParametersRouter,
  SOReportsRouter,
  SOSchedulesRouter,
  SOSchedulesAddRouter,
  SOSchedulesEditRouter,
]

export const SOAutomationRouterDetail = generateRouterDetail(SOAutomationRouter)

export default SOAutomationRouter
